'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

/**
 * Component that provides a list item.
 *
 * @example
 * <List.Item>Item</List.Item>
 */
const ListItem = forwardRef(function ListItem({ asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'li';
    return jsx(Component, { ...rest, ref: ref });
});

export { ListItem };
